import Content from '@/components/layout/Content'
import Footer from '@/components/layout/Footer'
import Header from '@/components/layout/Header'
import Wrapper from '@/components/layout/Wrapper'
import { COMMUNITIES } from '@/constants/common'
import WalkMiningWebApi from '@/util/client/WalkMiningWebApiConnector'
import { CommunityLinkData } from '@/util/types/CommonType'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { isAndroid, isDesktop, isIOS } from 'react-device-detect'

export default function InvitePage(props: any) {
  const { t } = useTranslation('translation')
  const route = useRouter()
  const { id, locale } = props

  const [copied, setCopied] = useState(false)
  const [validCode, setValidCode] = useState(false)

  useEffect(() => {
    const isValid = async (code: string) => {
      const res = await WalkMiningWebApi.validateInviteCode(false, code)
      if (res) {
        setValidCode(res)
      } else {
        setValidCode(false)
      }
    }
    if (id && typeof id === 'string') {
      isValid(id).catch(() => console.log('Validate API err'))
    }

    // check lang
    if (navigator && navigator.language) {
      if (navigator.language.includes('ko')) {
        route.push(`/ko/invite${id ? `?id=${id}` : ''}`)
      } else if (navigator.language.includes('ja')) {
        route.push(`/ja/invite${id ? `?id=${id}` : ''}`)
      }
    }
  }, [id])

  return (
    <>
      <Wrapper>
        <Content>
          <Header lng={locale} />
          <div
            className={`flex min-h-[calc(100vh-70px)] flex-col items-center bg-gradient-to-t from-[#9DE7E2] to-[#FFFDE7] pb-[180px] lg:min-h-[calc(100vh-100px)]`}
          >
            <div className={`mx-auto w-full`}>
              <img src={`/assets/images/invite/invite-illust.png`} alt={'illustration'} className={`w-full`} />
            </div>
            <div
              className={`mx-auto w-full px-[30px] text-center text-[16px] font-semibold text-[#000000] md:text-[24px]`}
            >
              <h1>{t('invite.title')}</h1>
              <p>{t('invite.description')}</p>
            </div>
            <div className={`mt-4 flex w-[325px] justify-between rounded-lg bg-white px-4 py-2`}>
              {validCode ? (
                <>
                  <div
                    className={`flex basis-1/2 items-center justify-center text-center text-[16px] font-semibold text-[#000000]`}
                  >
                    {id}
                  </div>
                  <CopyToClipboard text={id as string} onCopy={() => setCopied(true)}>
                    <button
                      className={`flex basis-1/2 items-center justify-center space-x-2 rounded-full bg-[#FFCC2B] px-10 py-3 font-semibold text-[#000000] shadow-[inset_0_5px_6px_rgba(255,255,255,0.6)]`}
                    >
                      {copied ? t('invite.copy_code_done') : t('invite.copy_code')}
                      <img src={`/assets/images/invite/fi-rr-copy.svg`} alt={t('invite.copy_code') as string} />
                    </button>
                  </CopyToClipboard>
                </>
              ) : (
                <>
                  <div
                    className={`flex w-full flex-col items-center justify-center space-y-3 py-4 text-center text-[16px] font-semibold text-[#000000]`}
                  >
                    <div>{t('invite.notcode.title')}</div>
                    <div>{t('invite.notcode.description')}</div>
                    <a
                      href={`https://twitter.com/search?q=walkmining&src=typed_query&f=live`}
                      target={`_blank`}
                      className={`w-full rounded-full bg-[#5865F2] py-4 text-white transition-colors hover:bg-[#5865F2]/80`}
                      rel="noopener noreferrer"
                    >
                      {t('invite.get_invite_code_btn')}
                    </a>
                  </div>
                </>
              )}
            </div>
            <div
              className={`flex flex-row-reverse ${
                !isDesktop ? 'justify-center' : 'justify-between'
              } mt-4 w-[337px] items-center text-center`}
            >
              {isDesktop && (
                <>
                  <a
                    href={`https://play.google.com/store/apps/details?id=com.walkmining.app.prod`}
                    target={`_blank`}
                    rel="noopener noreferrer"
                  >
                    <img src={`/assets/images/app-store/google_play.png`} alt={`google`} className={`w-[160px]`} />
                  </a>
                  <a href={`https://apps.apple.com/app/id6443983559`} target={`_blank`} rel="noopener noreferrer">
                    <img src={`/assets/images/app-store/apple_store.png`} alt={`apple`} className={`w-[160px]`} />
                  </a>
                </>
              )}
              {isAndroid && (
                <a
                  href={`https://play.google.com/store/apps/details?id=com.walkmining.app.prod`}
                  target={`_blank`}
                  rel="noopener noreferrer"
                >
                  <img src={`/assets/images/app-store/google_play.png`} alt={`google`} className={`w-[160px]`} />
                </a>
              )}
              {isIOS && (
                <a href={`https://apps.apple.com/app/id6443983559`} target={`_blank`} rel="noopener noreferrer">
                  <img src={`/assets/images/app-store/apple_store.png`} alt={`apple`} className={`w-[160px]`} />
                </a>
              )}
            </div>
          </div>
        </Content>
        <Footer
          noticeTitle={t('about_notice_title')}
          aboutTitle={t('about_service_title')}
          terms={t('service_terms_of_service')}
          privacy={t('service_privacy_title')}
          communities={COMMUNITIES as CommunityLinkData[]}
        />
      </Wrapper>
    </>
  )
}

export async function getServerSideProps(ctx: any) {
  const isSSR = ctx.req !== null && ctx.req !== undefined
  const { id } = ctx.query

  var isValid = false
  if (id) {
    const res = await WalkMiningWebApi.validateInviteCode(true, id)
    if (res) {
      isValid = res
    } else {
      isValid = false
    }
  }

  return {
    props: {
      id: id || null,
      isValid,
      isSSR,
      locale: ctx.locale,
      ...(await serverSideTranslations(ctx.locale, ['translation'])),
    },
  }
}
